// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__NnVr9","disabled":"FileBtn_disabled__2S2jY","warn":"FileBtn_warn__LmR3J","fade":"FileBtn_fade__uJQk6"};